import { create } from 'zustand'
import { combine } from 'zustand/middleware'

const useSortHeaderStore = create(
  combine({ selectedView: 'table' }, (set) => ({
    setSelectedView: (newState: 'cards' | 'table') => set(() => ({ selectedView: newState }))
  }))
)

export default useSortHeaderStore
